import ApiService from "./apiservice";

export const IOService = {
    AddIo(payload) {
        return ApiService.post("AddIo", payload);
    },
    GetPeriodBeginAndEndDate(payload) {
        return ApiService.get("ioinfo/GetPeriodBeginAndEndDate", payload);
    },
    GetFullPeriodIoInfoWithinFlageOfRequestedPages(payload) {
        return ApiService.get("ioInfo/GetFullPeriodIoInfoWithinFlageOfRequestedPages", payload);
    },
    GetPersonIoInfo(payload) {
        return ApiService.get("ioInfo/GetPersonIoInfo", payload);
    },
    GetPersonIoInfoClockDump(payload) {
        return ApiService.get("ioInfo/GetPersonIoInfoClockDump", payload);
    },
    GetPersonMergeIo(payload) {
        return ApiService.get("ioInfo/GetPersonMergeIo", payload);
    },
    GetIoListForArchive(payload) {
        return ApiService.get("IoInfo/GetIoListForArchive", payload);
    },
    GetIoDetail(payload) {
        return ApiService.get("IoInfo/GetIoDetail", payload);
    },
    GetIoDetailForArchive(params) {
        return ApiService.get("IoInfo/GetIoDetailForArchive", params);
    },
    OprationOnInOutArchive(payload) {
        return ApiService.post("OprationOnInOutArchive", payload);
    },
    OprationOnInOutRequest(payload) {
        return ApiService.post("OprationOnInOutRequest", payload);
    },
    GetApproveDegree(payload) {
        return ApiService.get("IoInfo/GetApproveDegree", payload);
    },
    GetIoListForAdmin(payload) {
        return ApiService.get("IoInfo/GetIoListForAdmin", payload);
    },
    GetIoInfoInDate(payload) {
        return ApiService.get("IoInfo/GetIoInfoInDate", payload);
    },
    GetPersonConflict(payload) {
        return ApiService.get("IoInfo/GetPersonConflict", payload);
    },
    GetUnCompleteIo(payload) {
        return ApiService.get("IoInfo/GetUnCompleteIo", payload);
    },
    GetCompleteIo(payload) {
        return ApiService.get("IoInfo/GetCompleteIo", payload);
    },
    GetIoInfoDetailForAdmin(payload) {
        return ApiService.get("ioinfo/GetIoInfoDetailForAdmin", payload);
    },
    getClocksList() {
        return ApiService.get("ioinfo/getClocksList");
    },
};